/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Register_Onboarding_Select_Other_Jobs_Intro_DescInputs */

const en_register_onboarding_select_other_jobs_intro_desc = /** @type {(inputs: Register_Onboarding_Select_Other_Jobs_Intro_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select the additional positions you would like to apply for. Loading of additional jobs can take a moment since these are calculated individually based on your personal matching score.`)
};

const de_register_onboarding_select_other_jobs_intro_desc = /** @type {(inputs: Register_Onboarding_Select_Other_Jobs_Intro_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle die zusätzlichen Positionen aus, für die du dich bewerben möchtest. Das Laden kann etwas dauern, da wir deinen persönlichen Matching-Score individuell ausrechnen.`)
};

/**
* | output |
* | --- |
* | "Select the additional positions you would like to apply for. Loading of additional jobs can take a moment since these are calculated individually based on yo..." |
*
* @param {Register_Onboarding_Select_Other_Jobs_Intro_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const register_onboarding_select_other_jobs_intro_desc = /** @type {((inputs?: Register_Onboarding_Select_Other_Jobs_Intro_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_Onboarding_Select_Other_Jobs_Intro_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_register_onboarding_select_other_jobs_intro_desc(inputs)
	return en_register_onboarding_select_other_jobs_intro_desc(inputs)
});